import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  leave: {
    head: [
      {
        label: 'Month',
        align: 'left'
      },
      {
        label: 'Year',
        align: 'left',
      },
      {
        label: 'Status',
        align: 'left',
      },
      {
        label: 'Updated On',
        align: 'left',
      },
    ],
    body: []
  },
  isLoadingLeave: true,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_GET_LEAVE:
      var data = action.data.map(i => {
        return [i.month, i.year, { isStatus: true, name: i.status }, i.updatedOn]
      })
      return {
        ...state,
        leave: {
          head: [
            {
              label: 'Month',
              align: 'left',
              isFilter:true,
              filterVal:null,
              index:0
            },
            {
              label: 'Year',
              align: 'left',
              isFilter:true,
              filterVal:null,
              index:1
            },
            {
              label: 'Status',
              align: 'left',
              isFilter:true,
              filterVal:null,
              index:2
            },
            {
              label: 'Updated On',
              align: 'left',
            },
          ],
          body: data,
        },
        isLoadingLeave: false,
      }
    case types.FAILED_GET_LEAVE:
      return {
        ...state,
        leave: {
          head: [],
          body: []
        },
        isLoadingLeave: false,
      }
    case types.FETCH_GET_LEAVE:
      return {
        ...state,
        leave: {
          head: [],
          body: []
        },
        isLoadingLeave: true,
      }
    default:
      return state
  }
}
export default reducer